import React from 'react'
import SbEditable from 'storyblok-react'

import styles from './styles.module.scss'

const ImageComponent = (props) => {
	return (
		<SbEditable content={props.blok}>
			<img className={`image ${styles['image']} ${props.className || ''}`} src={props.blok.asset.filename} alt={props.blok.asset.alt} />
		</SbEditable>
	)
}

export default ImageComponent
